
import React from "react";
import { Box, Typography, Paper } from "@mui/material";



export default function OrderHeaderBlock({ header,t }) {

    const FIELDS = [
        { key: "orderNumber", label: t("Order Number"), },
        { key: "orderDate", label: t("Date"), },
        { key: "orderTotal", label: t("Total"), },
        { key: "paymentMethod", label: t("Payment Method"), },
    ];
    return (
        <Box sx={{ maxWidth: 910, display: "flex", flexDirection: "column", gap: 2 }}>
            <Box
                sx={{
                    display: { xs: "none", md: "flex" },
                    justifyContent: "space-between",
                    px: 2,
                }}
            >
                {FIELDS.map((field) => (
                    <Typography
                        key={field.key}
                        sx={{
                            fontFamily: "'Roboto Condensed', sans-serif",
                            fontWeight: 700,
                            fontSize: 14,
                            textTransform: "uppercase",
                            width: "25%",
                        }}
                    >
                        {field.label}
                    </Typography>
                ))}
            </Box>
            <Paper
                sx={{
                    backgroundColor: "#E9E9E9",
                    borderRadius: "10px",
                    px: 2.5,
                    py: 1.5,
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        rowGap: 2,
                        mt: 1,
                    }}
                >
                    {FIELDS.map((field) => (
                        <Box
                            key={field.key}
                            sx={{
                                width: { xs: "50%", sm: "25%" },
                                display: "flex",
                                flexDirection: "column",
                                gap: 0.3,
                            }}
                        >
                            <Typography
                                sx={{
                                    display: { xs: "block", md: "none" },
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    fontWeight: 700,
                                    fontSize: 11,
                                    textTransform: "uppercase",
                                    color: "#555",
                                    lineHeight: 1.1,
                                }}
                            >
                                {field.label}
                            </Typography>

                            <Typography
                                sx={{
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    fontSize: 14,
                                    lineHeight: "120%",
                                    color: "#101010",
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                {header?.[field.key] || ""}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Paper>
        </Box>
    );
}
